export { NotFoundPage as default } from "@chef/feature-app-shell";
